import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue"

const _hoisted_1 = {
  id: "subNavSignup",
  class: "simple-signup mobile-only"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "glyphicon glyphicon-remove" }, null, -1)
const _hoisted_3 = { class: "blurb" }
const _hoisted_4 = { class: "blog-title fc-preview-contextmenu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "decorated-divider" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "newsletter-signup-msgs" }, null, -1)
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"0"} }, "Thanks for signing up!", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  id: "submitNewsletterSuForm",
  value: "Sign me up!",
  class: "col-xs-12 btn btn-lg btn-prime-1"
}, null, -1)
const _hoisted_13 = { class: "checkbox pull-left" }
const _hoisted_14 = { class: "fine-print" }
const _hoisted_15 = { class: "checkbox pull-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    name: "partners",
    checked: "",
    "data-path-gdpr": "unchecked"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "fine-print remove-padding" }, [
    /*#__PURE__*/_createTextVNode("Please also opt me in for Exclusive Offers from Patheos’s Partners "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/privacy-policy",
      target: "_blank"
    }, "Privacy and Data Policy")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]

import { ref, inject, onMounted } from 'vue';
import { useField, useForm } from 'vee-validate';
import { useLogger } from 'vue-logger-plugin';
import { NewslettersService } from '../../services/newsletters.service';
import { GTMService } from '../../services/gtm.service';
import useNewsletterSubmit from '../../composables/newsletter.composable';
import { LocationService } from '../../services/location.service';
import useValidators from '../../composables/validators.composable';

// inject our newsletter service

export default /*#__PURE__*/_defineComponent({
  __name: 'WordpressCollapsable',
  props: {
    blogName: {
        type: String,
        default: ''
    },
    channelName: {
        type: String,
        default: ''
    },
    partner: {
        type: Boolean,
        default: false
    },
    sourceDesc: {
        type: String,
        default: ''
    },
    blogListId: {
        type: String,
        default: ''
    },
    channelListId: {
        type: String,
        default: ''
    },
    isDefaultChannel: {
        type: Boolean,
        default: false
    },
    pathUrl: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props;

const newslettersService: NewslettersService | undefined = inject('NewslettersService');
// inject our locationservice
const locationService: LocationService | undefined = inject('LocationService');

const gtmService: GTMService | undefined = inject('GTMService');
const { newsletterSubmit } = useNewsletterSubmit(newslettersService, gtmService);

// Define Component Input Properties


const logger = useLogger();

// Component Locally Tracked Values
const submitted = ref(false);
const error = ref('');
const isCookieLawZone = ref(false);
const showModal = ref(false);

// get validators
const { isRequired, isEmail } = useValidators();
// generate validation schema
const validationSchema = {
    email: (value: string) => isRequired(value) && isEmail(value),
    partners: () => true,
    channel: () => true,
};

// Form Configuration
const { handleSubmit, errors } = useForm({
    validationSchema,
    initialValues: {
        email: '',
        partners: !isCookieLawZone.value,
        channel: !isCookieLawZone.value
    }
});

// Field Configurations
const { value: email } = useField('email');
const { value: partners } = useField('partners');
const { value: channel } = useField('channel');

// Handle Form Submit
const submit = handleSubmit(async (form) => {
    logger.debug('submitting newsletter', form, props.channelListId, props.blogListId);

    // reset error message
    error.value = '';

    const newsletters = [props.blogListId];
    if (form.channel) {
        newsletters.push(props.channelListId);
    }

    // submit to newsletter service
    const { message, success } = await newsletterSubmit(
        newsletters,
        form.email,
        props.sourceDesc,
        partners.value,
        props.pathUrl
    );

    if (success) {
        submitted.value = true;
    } else {
        submitted.value = false;
        error.value = message;
    }
});

onMounted(async () => {
    isCookieLawZone.value = (await locationService?.isCookieLawZone()) || false;
    logger.debug('Setting cookie zone law', isCookieLawZone.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showModal.value = true), ["prevent"])),
      class: "type-color-prime-3 mobile-only-signup-btn visible-xs visible-sm",
      id: "subNavSignupLink",
      style: {"position":"relative","z-index":"10"}
    }, "Get newsletters and updates"),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showModal.value = false), ["prevent"]))
      }, [
        _createTextVNode("Close "),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" get the latest from"),
        _createElementVNode("div", _hoisted_4, _toDisplayString(decodeURIComponent(__props.blogName)), 1),
        _hoisted_5,
        _createTextVNode(" Sign up for our newsletter"),
        _hoisted_6
      ]),
      _createElementVNode("p", _hoisted_7, "Get updates from " + _toDisplayString(decodeURIComponent(__props.blogName)) + " delivered straight to your inbox", 1),
      (submitted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("form", {
              class: "text-left newsletter-signup-form",
              id: "newsletter-signup-form-head-collapsable",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "alert alert-danger",
                  role: "alert",
                  key: error
                }, _toDisplayString(error), 1))
              }), 128)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                name: "email",
                placeholder: "Enter email address",
                class: "col-xs-12",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
              }, null, 512), [
                [_vModelText, _unref(email)]
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "newsletter-optin",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(channel) ? (channel).value = $event : null))
                  }, null, 512), [
                    [_vModelCheckbox, _unref(channel)]
                  ]),
                  _createElementVNode("span", _hoisted_14, "Yes, I want the Patheos " + _toDisplayString(decodeURIComponent(__props.channelName)) + " Newsletter as well", 1)
                ], 512), [
                  [_vShow, isCookieLawZone.value]
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_17, 512), [
                [_vShow, isCookieLawZone.value]
              ])
            ], 32)
          ]))
    ], 512), [
      [_vShow, showModal.value == true]
    ])
  ], 64))
}
}

})